import _ from 'lodash';
import initialstate from '../../../../reducers/initialstate';
import * as types from '../../../../actions/actiontypes';

export default function oversightOtherProjectsreducer(state = initialstate.oversightotherProjects, action) {
	switch (action.type) {
		case types.GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT:
			if (action.response) {
				return action.response || state;
			}
			return state;				
			default:
				return state;
	}
}
